module.exports = __webpack_public_path__ + "img/icon12.629eb03f.png";